import { jsonCopy } from '../../../utility/genericUtility';
import { datiTitolareEffettivoBenefMorteInizializzato } from '../componentiBase/sezioniAnagrafica';

export const datiTitolareBenefMorteEff = jsonCopy(datiTitolareEffettivoBenefMorteInizializzato);


